// extracted by mini-css-extract-plugin
export default {"MenuItemsRight":"MenuItemsRight_MenuItemsRight__WTvUG"};